"use client";

import { GoogleOneTap, SignIn } from "@clerk/nextjs";
import { useTheme } from "next-themes";
import { dark } from "@clerk/themes";

export default function SigninPage() {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  return (
    <>
      <GoogleOneTap
        appearance={{
          baseTheme: isDark ? dark : undefined,
        }}
      />
      <SignIn
        appearance={{
          baseTheme: isDark ? dark : undefined,
        }}
        signUpUrl="/sign-up"
      />
    </>
  );
}
